import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { AuthProvider, Protected } from "@/context/AuthContext";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import OrderPage from "@/pages/OrderPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Categories from "@/pages/admin/Categories";
import Products from "@/pages/admin/Products";
import Orders from "@/pages/admin/Orders";
import Settings from "@/pages/admin/Settings";

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <AuthProvider>
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/produto/:id" element={<ProductPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/pedido/:id" element={<OrderPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="categorias" element={<Categories />} />
                <Route path="produtos" element={<Products />} />
                <Route path="pedidos" element={<Orders />} />
                <Route path="configuracoes" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" theme="dark" richColors />
          </AuthProvider>
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
